export default "__VITE_ASSET__EyEOVBFA__"